<template>
    <div style="height: 100%">
        <div style="display: flex; width: 100%">
            <div style="width: 90%; height: 40px">
                <el-row style="margin: 10px; width: 95%; display: flex; padding-left: 20px">
                    <el-input v-model="formDatas.afNumber" style="width: 140px;" placeholder="请输入配件编号" size="mini"
                        clearable></el-input>
                    <el-input v-model="formDatas.afName" style="width: 140px;" size="mini" placeholder="请输入名称"
                        clearable></el-input>
                    <el-select size="mini" v-model="formDatas.dmDelete" clearable @change="partserch" placeholder="请选择"
                        v-if="post == 2" style="width: 130px">
                        <el-option label="已删除" :value="2" key="2"></el-option>
                        <el-option label="未删除" :value="1" key="1"></el-option>
                    </el-select>
                    <el-select size="mini" v-model="formDatas.afStatus" clearable @change="partserch" placeholder="请选择"
                        style="width: 130px">
                        <el-option label="闲置" :value="1" key="1"></el-option>
                        <el-option label="报废" :value="2" key="2"></el-option>
                        <el-option label="维修" :value="3" key="3"></el-option>
                        <el-option label="领用" :value="4" key="4"></el-option>
                        <el-option label="借用" :value="5" key="5"></el-option>
                    </el-select>
                    <el-button type="info" size="mini" icon="el-icon-search" @click="partserch"
                        style="margin-left: 5px">搜索</el-button>
                    <el-button type="info" size="mini" icon="el-icon-search" @click="SerchMore"
                        style="margin-left: 5px">更多</el-button>
                    <el-button type="primary" size="mini" style="margin-right: 5px;"
                        @click="bulkImport = true">批量导入</el-button>
                    <el-dropdown size="mini" split-button type="warning" style="margin-right: 5px;" @click="Out()"
                        @command="Out">
                        导出
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item style="background-color: #E6A23C;color: white;"
                                command="1">导出全部</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                    <el-button type="danger" size="mini" @click="BulkDelete">批量删除</el-button>
                </el-row>
            </div>
            <div style="width: 10%; height: 40px">
                <el-row style=" margin: 10px; width: 95%;display: flex; flex-direction: row-reverse;">
                    <el-button type="success" size="mini" style="margin-right: 20px" @click="BoxOpen">新增配件</el-button>

                    <!-- <el-button type="warning" size="mini" style="margin-right: 10px;" @click="Out()">导出</el-button> -->
                </el-row>
            </div>
        </div>
        <div class="tablemain">
            <div class="tablecss">
                <div style="width: 100%">
                    <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData"
                        :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" :checkbox-option="checkboxOption" row-key-field-name="afId"
                        :cellSelectionOption="cellSelectionOption" style="width: 100%" :editOption="editOption" />
                    <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div class="table-pagination">
                    <ve-pagination :total="totalCount" :page-index="formDatas.currentPage"
                        :page-size="formDatas.pageSize" :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]"
                        @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" />
                </div>
            </div>
            <!-- 新增 -->
            <el-drawer :wrapperClosable="false" :title="edit == true ? '编辑配件' : '新增配件'" :before-close="handleClose"
                :visible.sync="dialog" direction="rtl" custom-class="demo-drawer" ref="drawer">
                <div class="demo-drawer__content" style="height: 90%;">
                    <el-form ref="formRef" :model="form" label-position="top" :rules="rules" style="height:100%">
                        <div
                            style="width: 100%;height: 100%; overflow-y: scroll;padding: 50px 50px 15px;overflow-x: hidden;">
                            <el-form-item label="配件名称" prop="afName">
                                <el-input v-model="form.afName" style="width: 80%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="配件编号" prop="afNumber">
                                <el-input v-model="form.afNumber" style="width: 80%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="资产所在地" prop="afAddress">
                                <el-input v-model="form.afAddress" style="width: 80%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="配件分类" prop="afcId">
                                <el-select v-model="form.afcId" placeholder="请选择分类">
                                    <el-option v-for="item in afcTypearr || []" :label="item.afcName"
                                        :value="item.afcId" :key="item.afcId">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="关联资产" prop="aaId">
                                <el-select v-model="form.aaId" placeholder="请选择">
                                    <el-option v-for="item in aaTypearr || []" :label="item.aaName" :value="item.aaId"
                                        :key="item.aaId">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="资产产商" prop="amId">
                                <el-select v-model="form.amId" placeholder="请选择">
                                    <el-option v-for="item in amTypearr || []" :label="item.amName" :value="item.amId"
                                        :key="item.amId">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="拥有方式" prop="afOwnerType">
                                <el-select v-model="form.afOwnerType" clearable @change="form.afMoneyBuy = '',
                                    form.afMoneyHireMonth = '', form.afMoneyHireYear = '', form.afMoneyHireManner = ''"
                                    placeholder="请选择" style="width: 130px">
                                    <el-option label="租用" value="租用" key="1"></el-option>
                                    <el-option label="自购" value="自购" key="2"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="采购单价" prop="afMoneyBuy" v-if="form.afOwnerType == '自购'">
                                <el-input v-model="form.afMoneyBuy" style="width: 80%;" placeholder="请输入"
                                    @input="$forceUpdate()"></el-input>
                            </el-form-item>
                            <el-form-item label="租用方式" prop="afMoneyHireManner" v-if="form.afOwnerType == '租用'">
                                <el-select v-model="form.afMoneyHireManner" clearable @change="
                                    form.afMoneyHireMonth = '', $forceUpdate()" placeholder="请选择" style="width: 130px">
                                    <el-option label="月租" value="月租" key="1"></el-option>
                                    <el-option label="年租" value="年租" key="2"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="月租单价" prop="afMoneyHireMonth"
                                v-if="form.afMoneyHireManner && form.afOwnerType == '租用'">
                                <el-input v-model="form.afMoneyHireMonth" style="width: 80%;" placeholder="请输入"
                                    @input="$forceUpdate()"></el-input>
                            </el-form-item>

                            <el-form-item label="购入日期" prop="afDateBuy">
                                <el-date-picker v-model="form.afDateBuy" type="date" value-format="yyyy-MM-dd"
                                    placeholder="选择日期">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item label="过保日期" prop="afDateWarranty">
                                <el-date-picker v-model="form.afDateWarranty" type="date" value-format="yyyy-MM-dd"
                                    placeholder="选择日期">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item label="备注" prop="afDes">
                                <el-input v-model="form.afDes" style="width: 80%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="图片" prop="afFiles">
                                <my-upload ref="Imgupload" @fileChange="fileChange" :filearr.sync="fileList"
                                    @removeAfter="removeAfter" :limit="limit" style="margin: 10px 5px 5px;">
                                </my-upload>
                            </el-form-item>
                            <el-form-item label="资产折旧规则" prop="ardId">
                                <el-select v-model="form.ardId" placeholder="请选择">
                                    <el-option v-for="item in RuleArr || []" :label="item.ardName" :value="item.ardId"
                                        :key="item.ardId">
                                    </el-option>
                                </el-select>
                            </el-form-item>

                        </div>
                    </el-form>
                </div>
                <div class="demo-drawer__footer" style="margin-top: 10px;">
                    <el-button @click="handleClose()" style="margin-left: 20%;">取 消</el-button>
                    <el-button type="primary" @click="SureBtn" style="margin-left: 150px;">
                        确 定</el-button>
                </div>
            </el-drawer>
            <!-- 详情 -->
            <el-dialog title="详情" :visible.sync="IsDetail" width="70%" top="8vh">
                <div style="display: flex;width: 95%;margin: 10px auto;">
                    <el-button type="success" size="mini" @click="addRelated"
                        style="margin-left: 10px">添加配件关联</el-button>
                    <el-button v-if="DetailArr.ajAssets" type="danger" size="mini" @click="removeRelated"
                        style="margin-left: 10px">解除配件管理</el-button>
                </div>
                <div style="max-height: 500px; overflow-y: scroll">
                    <el-descriptions :column="3" border :labelStyle="{
                        color: '#409EFF',
                        textAlign: 'center',
                        width: '14%',
                        fontSize: '12px'
                    }" :contentStyle="{
                        textAlign: 'center',
                        width: '18%',
                        fontSize: '12px'
                    }">
                        <el-descriptions-item label="配件名称">{{ DetailArr.afName }}</el-descriptions-item>
                        <el-descriptions-item label="配件编号">{{ DetailArr.afNumber }}</el-descriptions-item>
                        <el-descriptions-item label="配件分类">{{ DetailArr.afcName }}</el-descriptions-item>
                        <el-descriptions-item label="资产产商">{{ DetailArr.amName }}</el-descriptions-item>
                        <el-descriptions-item label="购入日期">{{ DetailArr.afDateBuy }}</el-descriptions-item>
                        <el-descriptions-item label="过保日期">{{ DetailArr.afDateWarranty }}</el-descriptions-item>
                        <el-descriptions-item label="拥有方式">{{ DetailArr.afOwnerType }}</el-descriptions-item>
                        <el-descriptions-item label="采购单价">{{ DetailArr.afMoneyBuy }}</el-descriptions-item>
                        <el-descriptions-item label="租用方式">{{ DetailArr.afMoneyHireManner }}</el-descriptions-item>
                        <el-descriptions-item label="月租">{{ DetailArr.afMoneyHireMonth }}</el-descriptions-item>
                        <el-descriptions-item label="年租">{{ DetailArr.afMoneyHireYear }}</el-descriptions-item>
                        <el-descriptions-item label="图片">
                            <el-image ref="scrImg" id="scrimg" v-if="DetailArr.afFiles"
                                :src="DetailArr.afFiles.split(',')[0]" alt="" fit="cover"
                                style="width: 100%;height: 50px;"
                                :preview-src-list="DetailArr.afFiles.split(',')"></el-image>
                        </el-descriptions-item>
                        <el-descriptions-item label="备注">{{ DetailArr.afDes }}</el-descriptions-item>
                        <el-descriptions-item label="折旧规则">{{ DetailArr.afRuleDepreciate }}</el-descriptions-item>
                        <el-descriptions-item label="当前使用者">{{ DetailArr.afBorrowAuName }}</el-descriptions-item>
                        <el-descriptions-item label="部门">{{ DetailArr.auDepartment }}</el-descriptions-item>
                        <!-- <el-descriptions-item label="归属">{{ DetailArr.auBelong }}</el-descriptions-item> -->
                        <el-descriptions-item label="">
                            <el-tag size="mini">{{ DetailArr.afStatus == 1 ? '闲置' : DetailArr.aaStatusaaStatus == 2 ?
                                '报废'
                                : DetailArr.aaStatusaaStatus
                                == 3 ? '维修' : '借用' }}</el-tag>
                        </el-descriptions-item>
                    </el-descriptions>
                    <div v-if="DetailArr.ajAssets" style="margin: 10px 20px;">关联资产</div>
                    <el-descriptions v-if="DetailArr.ajAssets" :column="3" border :labelStyle="{
                        color: '#409EFF',
                        textAlign: 'center',
                        width: '14%',
                        fontSize: '12px'
                    }" :contentStyle="{
                        textAlign: 'center',
                        width: '18%',
                        fontSize: '12px'
                    }">
                        <el-descriptions-item label="型号">{{ DetailArr.ajAssets.aaName }}</el-descriptions-item>
                        <el-descriptions-item label="资产编号">{{ DetailArr.ajAssets.aaNumber }}</el-descriptions-item>
                        <el-descriptions-item label="资产分类">{{ DetailArr.ajAssets.aacName }}</el-descriptions-item>
                        <el-descriptions-item label="资产产商">{{ DetailArr.ajAssets.amName }}</el-descriptions-item>
                        <el-descriptions-item label="购入日期">{{ DetailArr.ajAssets.aaDateBuy }}</el-descriptions-item>
                        <el-descriptions-item label="过保日期">{{ DetailArr.ajAssets.aaDateWarranty
                            }}</el-descriptions-item>
                        <el-descriptions-item label="拥有方式">{{ DetailArr.aaOwnerType }}</el-descriptions-item>
                        <el-descriptions-item label="采购单价">{{ DetailArr.aaMoneyBuy }}</el-descriptions-item>
                        <el-descriptions-item label="租用方式">{{ DetailArr.aaMoneyHireManner }}</el-descriptions-item>
                        <el-descriptions-item label="月租">{{ DetailArr.aaMoneyHireMonth }}</el-descriptions-item>
                        <el-descriptions-item label="年租">{{ DetailArr.aaMoneyHireYear }}</el-descriptions-item>
                        <el-descriptions-item label="购买渠道">{{ DetailArr.ajAssets.aaPurchaseChannels
                            }}</el-descriptions-item>

                        <el-descriptions-item label="配置">{{ DetailArr.ajAssets.aaConfiguration }}</el-descriptions-item>
                        <el-descriptions-item label="SN码">{{ DetailArr.ajAssets.aaCodeSn }}</el-descriptions-item>
                        <el-descriptions-item label="绑定账号">{{ DetailArr.ajAssets.aaBindAccount }}</el-descriptions-item>
                        <el-descriptions-item label="折旧规则">{{ DetailArr.ajAssets.aaRuleDepreciate
                            }}</el-descriptions-item>
                        <el-descriptions-item label="当前使用者">{{ DetailArr.ajAssets.aaBorrowAuName
                            }}</el-descriptions-item>
                        <el-descriptions-item label="关联配件">{{ DetailArr.ajAssets.ajFittingsList
                            }}</el-descriptions-item>
                        <el-descriptions-item label="备注">{{ DetailArr.ajAssets.aaDes }}</el-descriptions-item>
                        <el-descriptions-item label="设备状态">
                            <el-tag size="mini">{{ DetailArr.ajAssets.aaStatus == 1 ? '闲置' :
                                DetailArr.ajAssets.aaStatus == 2 ? '报废' : DetailArr.ajAssets.aaStatus
                                    == 3 ? '维修' : DetailArr.ajAssets.aaStatus == 4 ? '领用' : DetailArr.ajAssets.aaStatus == 5
                                        ? '借用' :
                                        DetailArr.ajAssets.aaStatus == 6 ? '退租' : '丢失' }}</el-tag>
                        </el-descriptions-item>
                    </el-descriptions>
                </div>
            </el-dialog>
            <!-- 添加关联 -->
            <el-dialog title="关联资产" :visible.sync="Related" width="30%" :before-close="handleClose">
                <div style="width: 70%; margin: 10px auto;">
                    <el-select v-model="form.aaId" placeholder="请选择" @change="$forceUpdate()">
                        <el-option v-for="item in aaTypearr || []" :label="item.aaName" :value="item.aaId"
                            :key="item.aaId">
                        </el-option>
                    </el-select>
                </div>

                <span slot="footer" class="dialog-footer">
                    <el-button @click="Related = false">取 消</el-button>
                    <el-button type="primary" @click="sureRelated">确 定</el-button>
                </span>
            </el-dialog>
            <!-- 筛选 -->
            <el-dialog title="更多搜索" :visible.sync="IsSerch" width="70%" top="8vh" :close-on-click-modal="false">
                <div style=" width: 94%; height: 90%;margin:1% auto;background-color: white;overflow-y: scroll;">
                    <div style="width: 100%; height: 100%; padding: 5%">
                        <el-form ref="formDatas" :model="formDatas" label-position="left" label-width="150px"
                            @submit.native.prevent>
                            <div style="width: 50%; display: inline-block">
                                <el-form-item label="配件名称">
                                    <el-input v-model="formDatas.afName" style="width: 80%;"
                                        placeholder="请输入"></el-input>
                                </el-form-item>
                                <el-form-item label="资产编号">
                                    <el-input v-model="formDatas.afNumber" style="width: 80%;"
                                        placeholder="请输入"></el-input>
                                </el-form-item>
                                <el-form-item label="姓名">
                                    <el-input v-model="formDatas.afBorrowAuName" style="width: 80%;"
                                        placeholder="请输入"></el-input>
                                </el-form-item>
                                <!-- <el-form-item label="归属">
                                    <el-input v-model="formDatas.auBelong" style="width: 80%;" placeholder="请输入"></el-input>
                                </el-form-item> -->
                                <el-form-item label="领用日期">
                                    <el-date-picker v-model="formDatas.aubrBorrowDateStart" type="date"
                                        value-format="yyyy-MM-dd" placeholder="选择开始日期" style="width: 45%;">
                                    </el-date-picker> -
                                    <el-date-picker v-model="formDatas.aubrBorrowDateEnd" type="date"
                                        value-format="yyyy-MM-dd" placeholder="选择结束日期" style="width: 45%;">
                                    </el-date-picker>
                                </el-form-item>
                                <el-form-item label="配件分类">
                                    <el-select v-model="formDatas.afcId" placeholder="请选择分类">
                                        <el-option v-for="item in afcTypearr || []" :label="item.afcName"
                                            :value="item.afcId" :key="item.afcId">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                            <div style="width: 50%; display: inline-block">
                                <el-form-item label="所在部门">
                                    <el-input v-model="formDatas.auDepartment" style="width: 80%;"
                                        placeholder="请输入"></el-input>
                                </el-form-item>
                                <el-form-item label="产商">
                                    <el-select v-model="formDatas.amId" placeholder="请选择分类">
                                        <el-option v-for="item in amTypearr || []" :label="item.amName"
                                            :value="item.amId" :key="item.amId">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="关联资产">
                                    <el-select v-model="formDatas.amId" placeholder="请选择分类">
                                        <el-option v-for="item in aaTypearr || []" :label="item.aaName"
                                            :value="item.aaId" :key="item.aaId">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="拥有方式">
                                    <el-select v-model="formDatas.afOwnerType" clearable placeholder="请选择"
                                        style="width: 130px">
                                        <el-option label="租用" value="租用" key="1"></el-option>
                                        <el-option label="自购" value="自购" key="2"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="设备状态">
                                    <el-select v-model="formDatas.afStatus" clearable @change="partserch"
                                        placeholder="请选择" style="width: 130px">
                                        <el-option label="闲置" :value="1" key="1"></el-option>
                                        <el-option label="报废" :value="2" key="2"></el-option>
                                        <el-option label="维修" :value="3" key="3"></el-option>
                                        <el-option label="领用" :value="4" key="4"></el-option>
                                        <el-option label="借用" :value="5" key="5"></el-option>
                                        <el-option label="退租" :value="6" key="6"></el-option>
                                        <el-option label="丢失" :value="7" key="7"></el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                            <el-form-item>
                                <el-button type="primary" @click="partserch(), IsSerch = false"
                                    style="margin-left: 100px">立即搜索</el-button>
                                <el-button @click="closeSizer()" style="margin-left: 200px">取消</el-button>
                            </el-form-item>
                        </el-form>

                    </div>
                </div>
            </el-dialog>
            <!-- 借出 -->
            <el-dialog :title="formBw.aubrBorrowReturn == 2 ? formBw.name + '[出借]' : formBw.name + '[领用]'"
                :visible.sync="ISborrow" width="70%" top="8vh">
                <div style=" width: 94%; height: 90%;margin:1% auto;background-color: white;overflow-y: scroll;">
                    <div style="width: 100%; height: 100%; padding: 5%">
                        <el-form ref="formBw" :model="formBw" label-position="top" label-width="150px"
                            @submit.native.prevent>
                            <el-form-item label="员工" prop="auId">
                                <el-select v-model="formBw.auId" filterable placeholder="请选择">
                                    <el-option v-for="item in userArr || []" :label="item.auName" :value="item.auId"
                                        :key="item.auId">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <!-- <el-form-item label="数量" prop="aubrThisNum">
                                <el-input v-model.number="formBw.aubrThisNum" style="width: 80%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item> -->
                            <el-form-item label="计划归还日期" prop="aubrReturnPlanDate">
                                <el-date-picker v-model="formBw.aubrReturnPlanDate" type="date"
                                    value-format="yyyy-MM-dd" placeholder="选择日期">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item label="领用日期" prop="aubrBorrowDate">
                                <el-date-picker v-model="formBw.aubrBorrowDate" type="date" value-format="yyyy-MM-dd"
                                    placeholder="选择日期">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item label="备注" prop="aubrThisDes">
                                <el-input v-model="formBw.aubrThisDes" style="width: 80%;" placeholder="请输入"></el-input>
                            </el-form-item>
                        </el-form>
                        <span slot="footer" class="dialog-footer">
                            <el-button @click="CloseBorrow">取 消</el-button>
                            <el-button type="primary" @click="sureBorrow">确 定</el-button>
                        </span>
                    </div>
                </div>
            </el-dialog>
            <!-- 故障 -->
            <el-dialog :title="formBk.name + '[故障]'" :visible.sync="ISBreak" width="70%" top="8vh">
                <div style=" width: 94%; height: 90%;margin:1% auto;background-color: white;overflow-y: scroll;">
                    <div style="width: 100%; height: 100%; padding: 5%">
                        <el-form ref="formBk" :model="formBk" label-position="top" label-width="150px"
                            @submit.native.prevent>

                            <el-form-item label="故障时间" prop="aahTime">
                                <el-date-picker v-model="formBk.aahTime" type="datetime"
                                    value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item label="故障说明" prop="aahDes">
                                <el-input v-model="formBk.aahDes" style="width: 80%;" placeholder="请输入"></el-input>
                            </el-form-item>
                        </el-form>
                        <span slot="footer" class="dialog-footer">
                            <el-button @click="CloseBreak">取 消</el-button>
                            <el-button type="primary" @click="sureBreak">确 定</el-button>
                        </span>
                    </div>
                </div>
            </el-dialog>
            <!-- 编辑日期 -->
            <el-dialog title="编辑日期" :visible.sync="dbtrue" width="50%" top="8vh">
                <el-date-picker v-model="dateUpdata" type="date" value-format="yyyy-MM-dd" placeholder="选择日期">
                </el-date-picker>
                <span slot="footer" class="dialog-footer">
                    <!-- <el-button @click="CloseBreak">取 消</el-button> -->
                    <el-button type="primary" @click="sureDate">确 定</el-button>
                </span>
            </el-dialog>
            <!-- 批量导入 -->
            <el-dialog title="批量导入" :visible.sync="bulkImport" width="70%" :before-close="bulkImportClose"
                style="margin-left: 200px;">
                <div style="margin: 0 10px 10px;display: flex;">
                    <el-upload class="upload-demo" action="#" accept=".xlsx,.xls" :on-change="updatabulk"
                        :auto-upload="false" ref="bulk" multiple>
                        <el-button size=" medium" type="danger">点击上传</el-button>

                    </el-upload>
                    <div>
                        <el-button type="primary"
                            @click="downloadFile('https://trainapp.aojuai.com/assets/excel/fitting.xlsx', '配件模板')"
                            style="margin-left: 20%;height: 40px;">下载模板</el-button>
                    </div>
                </div>
                <div>
                    <ve-table :columns="columnsImport" :table-data="bulkData" :max-height="500" :border-x="true"
                        :border-y="true" :scrollWidth="10" row-key-field-name="dataIndex"
                        :cell-style-option="cellStyleOption" style="width: 100%" />
                    <div v-show="bulkData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div style="margin: 10px;font-size: 18px;" v-if="bulkData.length != 0">
                    <span style="color: #0080FF;">一共{{ importData.numAll }}条;</span>
                    <span style="color: #0E9A00;margin-left: 5px;">成功{{ importData.numSuccess }}条;</span>
                    <span style="color: red;margin-left: 5px;">失败{{ importData.numFail }}条</span>
                    <span style="color: #E6A23C;margin-left: 5px;">信息不完整{{ importData.numUnWhole }}条</span>
                </div>
                <div slot="footer" class="dialog-footer" style="width:80%; margin: 10px auto;">
                    <!-- <el-button @click="bulkImportClose">取 消</el-button> -->
                    <el-button type="success" @click="bulkImportClick">确定导入</el-button>
                </div>
            </el-dialog>
            <!-- 借还记录 -->
            <el-dialog title="借还记录" :visible.sync="ReturnShow" width="70%" top="15vh">
                <div style="width: 90%;height: 100%;margin: 10px auto;overflow: hidden;">
                    <el-card v-for="(item, index) in ReturnArr" :key="index" style="margin: 10px;">
                        <p style="color: #E6A23C;">使&ensp;用&ensp;人:&emsp;{{ item.auName }}</p>
                        <p style="color: #0e0d0d;">领用日期:&emsp;{{ item.aubrBorrowDate }}</p>
                        <p style="color: #0e0d0d;"> 领借类型:&emsp;{{ item.aubrBorrowReturn == 1 ? '领用' : '借用' }}</p>
                        <p style="color: #0E9A00;" v-if="item.aubrBorrowStatus == 1"> 借还状态:&emsp;在使用</p>
                        <p style="color: #0e0d0d;" v-if="item.aubrBorrowStatus == 2"> 借还状态:&emsp;已归还</p>
                        <p style="color: #9a0015;" v-if="item.aubrBorrowStatus == 3"> 借还状态:&emsp;已损耗</p>
                        <p style="color: #0e0d0d;">归还时间:&emsp;{{ item.returntime }}</p>

                    </el-card>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>

import {
    getAjFittingsList, addAjFittings, updateAjFittings, deleteAjFittings, getAjAssetsItems, updateAjFittingsReturn,
    getAjManufacturerList, getAjFittingsClassList, getAjAssetsList, getAjFittingsDetails,
    updateAjFittingsAssetsUnbinding, updateAjFittingsAssets, getAjUserList, getAjRuleDepreciationList, addAjAssetsHitch, addAjUserBorrow,
    exportAjFittings, uploadAjFittings, uploadImportAjFittings, updateAjFittingsReturnStore, getAjUserBorrowReturnList
} from "../../api/api";
import { BrowserQRCodeSvgWriter } from '@zxing/browser';
export default {
    name: "",
    components: {},
    data() {
        return {
            ReturnZc: false,
            hasFitting: '',
            sitId: '',
            TemstrongArr: [],
            importData: {},
            bulkData: [],
            bulkDataCopy: [],
            bulkImport: false,
            columnsImport: [
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    align: "center",
                    fixed: 'left',
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "status",
                    key: "status",
                    title: "状态",
                    width: 150,
                    align: "center",
                    fixed: 'left',
                    filter: {
                        filterList: [
                            { value: 0, label: '成功', selected: false },
                            { value: 1, label: '失败', selected: false },
                            { value: 3, label: '信息不完整', selected: false }
                        ],
                        isMultiple: true,
                        // filter confirm hook
                        filterConfirm: (filterList) => {
                            console.log(filterList);
                            const labels = filterList
                                .filter((x) => x.selected)
                                .map((x) => x.label);
                            this.searchByNameField(labels, 'status');
                        },
                        // filter reset hook
                        filterReset: (filterList) => {
                            this.searchByNameField([]);
                        },
                        // max height
                        maxHeight: 120,
                    },
                },
                {
                    field: "statusMsg",
                    key: "statusMsg",
                    title: "状态备注",
                    width: 150,
                    align: "center",


                },
                {
                    field: "afName",
                    key: "b",
                    title: "配件名称",
                    align: "center",

                    width: 100,

                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <el-button
                                    size="mini"
                                    type="text"

                                >
                                    {row.afName}
                                </el-button>

                            </span>
                        );
                    },
                },
                {
                    field: "afNumber",
                    key: "afNumber",
                    title: "配件编号",
                    fixed: 'left',
                    width: 150,
                    align: "center",

                },
                {
                    field: "afcName",
                    key: "afcName",
                    title: "配件分类",
                    width: 100,
                    align: "center",

                },
                {
                    field: "amName",
                    key: "amName",
                    title: "资产厂商",
                    align: "center",
                    width: 100,

                },
                // {
                //     field: "aaName",
                //     key: "aaName",
                //     title: "关联资产",
                //     align: "center",
                //     width: 100,

                // },
                {
                    field: "afDateBuy",
                    key: "afDateBuy",
                    title: "购入日期",
                    align: "center",
                    edit: false,
                    width: 200,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <div style="width:100%;height:40px;line-height:40px;" >{row.afDateBuy}</div>
                            </span>
                        );
                    },
                },

                {
                    field: "afDateWarranty",
                    key: "afDateWarranty",
                    title: "过保日期",
                    align: "center",
                    edit: false,
                    width: 200,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <div style="width:100%;height:40px;line-height:40px;" >{row.afDateWarranty}</div>
                            </span>
                        );
                    },
                },
                {
                    field: "afOwnerType",
                    key: "afOwnerType",
                    title: "拥有方式",
                    align: "center",

                    width: 100,
                },


                {
                    field: "afDes",
                    key: "afDes",
                    title: "备注",
                    align: "center",

                    width: 150,
                    ellipsis: {
                        showTitle: true,
                        lineClamp: 2,
                    },
                },
                {
                    field: "afFiles",
                    key: "afFiles",
                    title: "图片",
                    width: 150,
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.afFiles ? <el-image ref="scrImg" id="scrimg" src={row.afFiles.split(',')[0]} alt="" fit="fill" style="width: 100%;height: 50px;"
                                        previewSrcList={row.afFiles.split(',')}></el-image> : <span></span>
                                }


                            </span>
                        );
                    },
                },
                {
                    field: "ardName",
                    key: "ardName",
                    title: "折旧规则",
                    align: "center",
                    // edit: true,
                    width: 150,
                    ellipsis: {
                        showTitle: true,
                        lineClamp: 2,
                    },
                },
                { field: "createtime", key: "c", title: "创建时间", width: 160, align: "center" },



            ], //表格的列

            dateUpdata: '',
            dbtrue: false,
            formBk: {

            },
            ISBreak: false,
            fileList: [],
            limit: 6,
            userArr: [],
            formBw: {

            },
            ISborrow: false,

            RuleArr: [],
            Related: false,
            afcTypearr: [],
            aacTypearr: [],
            aaTypearr: [],//
            amTypearr: [],//厂商
            IsSerch: false,
            dialog: false,
            edit: false,
            form: {
                afFiles: '',
            },
            rules: {
                afName: [{
                    required: true,
                    message: '请输入名称',
                    trigger: 'blur'
                }
                ],
                afNumber: [{
                    required: true,
                    message: '请输入编号',
                    trigger: 'blur'
                }
                ],
            },
            DetailArr: [],
            IsDetail: false,
            // 未编辑前的值
            lastValue: "",
            // 单元格编辑功能
            editOption: {
                beforeCellValueChange: ({ row, column, changeValue }) => {
                    this.beforeCellValChange(row, column, changeValue);
                },
                afterCellValueChange: ({ row, column, changeValue }) => {
                    this.afterCellValChange(row, column, changeValue);
                },
            },
            cellSelectionOption: {
                // disble cell selection
                enable: true,
            },
            totalCount: 100,
            pageIndex: 1,
            pageSize: 20,
            selectedRowKeysCollection: [],
            checkboxOption: {
                // 可控属性
                selectedRowKeys: [],
                // 行选择改变事件
                selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
                    this.changeSelectedRowKeys(row, isSelected);
                },
                // 全选改变事件
                selectedAllChange: ({ isSelected, selectedRowKeys }) => {
                    this.changeSelectAll(isSelected, selectedRowKeys);
                },
            },
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => {
                    if (rowIndex === 0) {
                        return "table-header-cell-class";
                    }
                },
            },
            windheight: "",
            tableHight: 520,
            columns: [
                {
                    field: "",
                    key: "checkbox",
                    // type=checkbox
                    type: "checkbox",
                    fixed: 'left',
                    title: "",
                    width: 50,
                    align: "center",
                },
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    fixed: 'left',
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "afName",
                    key: "b",
                    title: "配件名称",
                    align: "center",
                    fixed: 'left',
                    width: 100,
                    edit: true,
                    filter: {
                        filterList: [

                        ],
                        isMultiple: true,
                        // filter confirm hook
                        filterConfirm: (filterList) => {
                            console.log(filterList);
                            const labels = filterList
                                .filter((x) => x.selected)
                                .map((x) => x.label);
                            console.log(labels);
                            this.searchByNameFieldCopy(labels, 'afNameListString');
                        },
                        // filter reset hook
                        filterReset: (filterList) => {
                            this.searchByNameFieldCopy([], 'afNameListString');
                        },
                        // max height
                        maxHeight: 200,
                        beforeVisibleChange: ({ nextVisible }) => {
                            if (nextVisible) {
                                this.ob(2, 'afName')
                                console.log(nextVisible);
                            }
                        }
                    },
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <el-button
                                    size="mini"
                                    type="text"
                                    on-click={() => this.getDetail(row.afId)}
                                >
                                    {row.afName}
                                </el-button>

                            </span>
                        );
                    },
                },
                {
                    field: "afAddress",
                    key: "afAddress",
                    title: "资产所在地",
                    fixed: 'left',
                    width: 120,
                    align: "center",
                    edit: true,
                    filter: {
                        filterList: [

                        ],
                        isMultiple: true,
                        // filter confirm hook
                        filterConfirm: (filterList) => {
                            console.log(filterList);
                            const labels = filterList
                                .filter((x) => x.selected)
                                .map((x) => x.label);
                            console.log(labels);
                            this.searchByNameFieldCopy(labels, 'afAddressListString');
                        },
                        // filter reset hook
                        filterReset: (filterList) => {
                            this.searchByNameFieldCopy([], 'afAddressListString');
                        },
                        // max height
                        maxHeight: 200,
                        beforeVisibleChange: ({ nextVisible }) => {
                            if (nextVisible) {
                                this.ob(3, 'afAddress')
                                console.log(nextVisible);
                            }
                        }
                    },
                },
                // {
                //     field: "auBelong",
                //     key: "auBelong",
                //     title: "归属",
                //     align: "center",
                //     // edit: true,
                //     width: 150,
                //     ellipsis: {
                //         showTitle: true,
                //         lineClamp: 2,
                //     },
                // },
                {
                    field: "afBorrowAuName",
                    key: "afBorrowAuName",
                    title: "当前使用人",
                    align: "center",
                    // edit: true,
                    width: 110,
                    ellipsis: {
                        showTitle: true,
                        lineClamp: 2,
                    },
                    filter: {
                        filterList: [

                        ],
                        isMultiple: true,
                        // filter confirm hook
                        filterConfirm: (filterList) => {
                            console.log(filterList);
                            const labels = filterList
                                .filter((x) => x.selected)
                                .map((x) => x.label);
                            console.log(labels);
                            this.searchByNameFieldCopy(labels, 'afBorrowAuNameListString');
                        },
                        // filter reset hook
                        filterReset: (filterList) => {
                            this.searchByNameFieldCopy([], 'afBorrowAuNameListString');
                        },
                        // max height
                        maxHeight: 200,
                        beforeVisibleChange: ({ nextVisible }) => {
                            if (nextVisible) {
                                this.ob(4, 'afBorrowAuName')
                                console.log(nextVisible);
                            }
                        }
                    },
                },
                {
                    field: "auDepartment",
                    key: "auDepartment",
                    title: "部门",
                    align: "center",
                    // edit: true,
                    width: 150,
                    ellipsis: {
                        showTitle: true,
                        lineClamp: 2,
                    },
                    filter: {
                        filterList: [

                        ],
                        isMultiple: true,
                        // filter confirm hook
                        filterConfirm: (filterList) => {
                            console.log(filterList);
                            const labels = filterList
                                .filter((x) => x.selected)
                                .map((x) => x.label);
                            console.log(labels);
                            this.searchByNameFieldCopy(labels, 'auDepartmentListString');
                        },
                        // filter reset hook
                        filterReset: (filterList) => {
                            this.searchByNameFieldCopy([], 'auDepartmentListString');
                        },
                        // max height
                        maxHeight: 200,
                        beforeVisibleChange: ({ nextVisible }) => {
                            if (nextVisible) {
                                this.ob(5, 'auDepartment')
                                console.log(nextVisible);
                            }
                        }
                    },
                },
                {
                    field: "afNumber",
                    key: "afNumber",
                    title: "配件编号",
                    fixed: 'left',
                    width: 130,
                    align: "center",
                    edit: true,
                },
                {
                    field: "afcName",
                    key: "afcName",
                    title: "配件分类",
                    width: 100,
                    align: "center",
                    filter: {
                        filterList: [

                        ],
                        isMultiple: true,
                        // filter confirm hook
                        filterConfirm: (filterList) => {
                            console.log(filterList);
                            const labels = filterList
                                .filter((x) => x.selected)
                                .map((x) => x.label);
                            console.log(labels);
                            this.searchByNameFieldCopy(labels, 'afcNameListString');
                        },
                        // filter reset hook
                        filterReset: (filterList) => {
                            this.searchByNameFieldCopy([], 'afcNameListString');
                        },
                        // max height
                        maxHeight: 200,
                        beforeVisibleChange: ({ nextVisible }) => {
                            if (nextVisible) {
                                this.ob(7, 'afcName')
                                console.log(nextVisible);
                            }
                        }
                    },

                },
                {
                    field: "amName",
                    key: "amName",
                    title: "资产厂商",
                    align: "center",
                    width: 100,

                },
                // {
                //     field: "aaName",
                //     key: "aaName",
                //     title: "关联资产",
                //     align: "center",
                //     width: 100,

                // },
                {
                    field: "afDateBuy",
                    key: "afDateBuy",
                    title: "购入日期",
                    align: "center",
                    edit: false,
                    width: 120,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <div style="width:100%;height:40px;line-height:40px;" onDblclick={() => this.getdbtrue(row.afDateBuy, 'afDateBuy', rowIndex, row.afId)}>{row.afDateBuy}</div>
                            </span>
                        );
                    },
                },

                {
                    field: "afDateWarranty",
                    key: "afDateWarranty",
                    title: "过保日期",
                    align: "center",
                    edit: false,
                    width: 120,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <div style="width:100%;height:40px;line-height:40px;" onDblclick={() => this.getdbtrue(row.afDateWarranty, 'afDateWarranty', rowIndex, row.afId)}>{row.afDateWarranty}</div>
                            </span>
                        );
                    },
                },
                {
                    field: "afOwnerType",
                    key: "afOwnerType",
                    title: "拥有方式",
                    align: "center",
                    // edit: true,
                    width: 100,
                },
                {
                    field: "afMoneyBuy",
                    key: "afMoneyBuy",
                    title: "采购单价",
                    align: "center",
                    // edit: true,
                    width: 100,
                },
                {
                    field: "afMoneyHireManner",
                    key: "afMoneyHireManner",
                    title: "租用方式",
                    align: "center",
                    // edit: true,
                    width: 100,
                },
                {
                    field: "afMoneyHireMonth",
                    key: "afMoneyHireMonth",
                    title: "月租单价",
                    align: "center",
                    // edit: true,
                    width: 100,
                },
                {
                    field: "afMoneyHireYear",
                    key: "afMoneyHireYear",
                    title: "年租单价",
                    align: "center",
                    // edit: true,
                    width: 100,
                },
                {
                    field: "afDes",
                    key: "afDes",
                    title: "备注",
                    align: "center",
                    edit: true,
                    width: 150,
                    ellipsis: {
                        showTitle: true,
                        lineClamp: 2,
                    },
                },
                {
                    field: "afFiles",
                    key: "afFiles",
                    title: "图片",
                    width: 150,
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.afFiles ? <el-image ref="scrImg" id="scrimg" src={row.afFiles.split(',')[0]} alt="" fit="fill" style="width: 100%;height: 50px;"
                                        previewSrcList={row.afFiles.split(',')}></el-image> : <span></span>
                                }


                            </span>
                        );
                    },
                },
                {
                    field: "ardName",
                    key: "ardName",
                    title: "折旧规则",
                    align: "center",
                    // edit: true,
                    width: 150,
                    ellipsis: {
                        showTitle: true,
                        lineClamp: 2,
                    },
                },
                { field: "createtime", key: "c", title: "创建时间", width: 160, align: "center" },
                {
                    field: "afStatus",
                    key: "afStatus",
                    title: "设备状态",
                    align: "center",
                    width: 100,
                    fixed: 'right',
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.afStatus == 1 ? <el-tag size="mini" type="success" > 闲置 </el-tag> : row.afStatus == 2 ? <el-tag size="mini" type="info" > 报废 </el-tag> :
                                        row.afStatus == 3 ? <el-tag size="mini" type="warning" > 维修 </el-tag> : row.afStatus == 4 ? <el-tag size="mini" type="danger" > 领用 </el-tag> :
                                            row.afStatus == 5 ? <el-tag size="mini" type="danger" > 借用 </el-tag> : row.afStatus == 6 ? <el-tag size="mini" type="danger" > 退租 </el-tag> : <el-tag size="mini" type="danger" > 丢失 </el-tag>
                                }
                            </span>
                        );
                    },

                },
                {
                    field: "",
                    key: "d",
                    title: "操作",
                    width: 280,
                    fixed: 'right',
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <el-button
                                    size="mini"
                                    type="text"
                                    on-click={() => this.handleDown(row)}
                                >
                                    下载二维码
                                </el-button>
                                {
                                    row.afStatus == 4 || row.afStatus == 5 ? <el-button
                                        size="mini"
                                        type="text"
                                        style="color: #E6A23C;margin-right:10px"
                                        on-click={() => this.returnFittings(row)}
                                    >
                                        归还
                                    </el-button> : <span></span>
                                }
                                {
                                    row.afOwnerType == '租用' && row.afStatus != 6 ? <el-button
                                        size="mini"
                                        type="text"
                                        style="color: #E6A23C;margin-right:10px"
                                        on-click={() => this.throwALease(row)}
                                    >
                                        退租
                                    </el-button> : <span></span>
                                }
                                {
                                    row.afStatus != 2 && row.afStatus != 3 ? <el-button
                                        size="mini"
                                        type="text"
                                        style="color: #E6A23C;margin-right:10px"
                                        on-click={() => this.addBreak(row)}
                                    >
                                        报告故障
                                    </el-button> : <span></span>
                                }
                                {
                                    row.afStatus == 1 ? <el-button
                                        size="mini"
                                        type="text"
                                        style="color: #67C23A"
                                        on-click={() => this.addBorrow(row, 2)}
                                    >
                                        出借
                                    </el-button> : <span></span>
                                }
                                {
                                    row.afStatus == 1 ? <el-button
                                        size="mini"
                                        type="text"
                                        style="color: red"
                                        on-click={() => this.addBorrow(row, 1)}
                                    >
                                        领用
                                    </el-button> : <span></span>
                                }
                                <el-button
                                    size="mini"
                                    type="text"
                                    on-click={() => this.getHis(row)}
                                >
                                    借还记录
                                </el-button>
                                <el-button
                                    size="mini"
                                    type="text"
                                    on-click={() => this.handleEdit(row)}
                                >
                                    编辑
                                </el-button>
                                <el-button
                                    size="mini"
                                    type="text"
                                    style="color: red"
                                    on-click={() => this.handleDelete(row)}
                                >
                                    删除
                                </el-button>
                            </span>
                        );
                    },
                },
            ], //表格的列
            tableData: [],
            post: null,
            formDatas: {
                afBorrowAuName: '',
                auBelong: '',
                auDepartment: '',
                aaId: '',
                afName: '',
                afNumber: '',
                afcId: '',
                amId: '',
                afOwnerType: '',
                afStatus: '',
                dmDelete: 1,
                currentPage: 1,
                pageSize: 20,
            },
            ReturnArr: [],
            ReturnShow: false,
        };
    },
    activated() {
        getAjUserList({ checkStatus: 2 }).then(res => {
            this.userArr = res.data
        })
        getAjRuleDepreciationList().then(res => {
            this.RuleArr = res.data
        })
        getAjManufacturerList().then(res => {
            this.amTypearr = res.data
        })
        getAjFittingsClassList().then(res => {
            this.afcTypearr = res.data
        })
        getAjAssetsList().then(res => {
            this.aaTypearr = res.data
        })
        this.getList();
        this.watchFlag = true;
        this.$nextTick(() => {
            this.windheight = this.$store.state.windheight;
            this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        });
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                if (this.watchFlag) {
                    this.tableHight = val - 200 - val * 0.04;
                }
            });
        },
    },
    deactivated() {
        this.watchFlag = false;
    },
    created() {
        this.windheight = this.$store.state.windheight
        this.tableHight = this.windheight - 200 - this.windheight * 0.04;

    },
    mounted() {

    },
    methods: {
        async handleDown(row) {
            // 创建二维码
            const writer = new BrowserQRCodeSvgWriter();
            const qrSvg = await writer.write(row.afNumberUrl, 200, 200);

            // 创建文字元素
            const textElement = document.createElementNS('http://www.w3.org/2000/svg', 'text');
            textElement.setAttribute('x', '100');
            textElement.setAttribute('y', '195');
            textElement.setAttribute('text-anchor', 'middle');
            textElement.setAttribute('font-family', 'Arial, sans-serif');
            textElement.setAttribute('font-size', '14');
            textElement.setAttribute('fill', '#000');
            textElement.textContent = '';

            // 创建组合SVG
            const combinedSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
            combinedSvg.setAttribute('viewBox', '0 0 200 195');
            combinedSvg.setAttribute('width', '200');
            combinedSvg.setAttribute('height', '200');
            combinedSvg.appendChild(qrSvg);
            combinedSvg.appendChild(textElement);

            // 转换为PNG
            const svgBlob = new Blob([new XMLSerializer().serializeToString(combinedSvg)], { type: 'image/svg+xml' });
            const url = URL.createObjectURL(svgBlob);

            const img = new Image();
            img.src = url;

            await new Promise((resolve) => {
                img.onload = resolve;
                img.onerror = () => {
                    URL.revokeObjectURL(url);
                    throw new Error('图片加载失败');
                };
            });

            const canvas = document.createElement('canvas');
            canvas.width = 200;
            canvas.height = 210;

            const ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0);
            // 清理资源
            URL.revokeObjectURL(url);
            // 下载PNG
            let qrImageUrl = ''
            qrImageUrl = canvas.toDataURL('image/png');
            URL.revokeObjectURL(img);
            const link = document.createElement('a');
            link.href = qrImageUrl;
            link.download = row.afName + '---' + row.afNumber + '.png';
            link.click();
        },
        getHis(row) {
            getAjUserBorrowReturnList({ afId: row.afId }).then(res => {
                if (res.data) {
                    this.ReturnArr = res.data;
                    this.ReturnShow = true;
                }
            })
        },
        // 批量删除
        BulkDelete() {
            if (this.selectedRowKeysCollection.length == 0) {
                this.$message({
                    showClose: true,
                    message: "请选择",
                    type: 'danger'
                });
            } else if (this.selectedRowKeysCollection.length > 0) {
                this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        deleteAjFittings({ afIds: this.selectedRowKeysCollection.toString() }).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "删除成功!",
                                });

                                this.partserch()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }
        },
        returnFittings(row) {
            this.$confirm("是否确定要归还吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    updateAjFittingsReturn({ afId: row.afId }).then(res => {
                        this.$message({
                            type: "success",
                            message: '归还成功',
                        });
                        this.getList();
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        async ob(i, item) {
            const filterarr = []
            const data = await getAjAssetsItems({ itemType: 3, item })
            console.log(data);
            if (this.formDatas[item + 'ListString']) {
                const arr = this.formDatas[item + 'ListString'].split(',')
                arr.forEach((datas, i) => {
                    data.data.forEach((ite, index) => {
                        if (datas == ite.name) {
                            console.log(datas);
                            const s = {
                                label: ite.name + `[${ite.num}]`,
                                selected: true,
                                value: index
                            }
                            filterarr.push(s)

                        }
                        const s = {
                            label: ite.name + `[${ite.num}]`,
                            selected: true,
                            value: index
                        }
                        filterarr.push(s)
                    })
                })
                let map = new Map();
                let filterList = []
                for (let itt of filterarr) {
                    map.set(itt.id, itt)
                }
                filterList = [...map.values()]
                filterarr = filterList
            } else {
                data.data.forEach((ite, index) => {
                    console.log('初始化');
                    const s = {
                        label: ite.name + `[${ite.num}]`,
                        selected: false,
                        value: index
                    }
                    filterarr.push(s)
                })
            }
            this.$nextTick(() => {
                this.$set(this.columns[i].filter, 'filterList', filterarr)
                this.$refs['vetable'].colgroups[i].filter.filterList = filterarr

            })
        },
        searchByNameField(labels, id) {
            this.bulkData = this.bulkDataCopy.filter(
                (x) => labels.length === 0 || labels.includes(x[id]),
            );
        },
        searchByNameFieldCopy(labels, id) {
            if (labels == []) {
                this.formDatas[id] = '';
                this.partserch()
                return
            }
            const arr = labels
            labels.forEach((item, index) => {
                const a = item.indexOf('[');
                arr[index] = item.substring(0, a);
            })
            this.formDatas[id] = arr.toString();
            this.partserch()
            // this.bulkData = this.bulkDataCopy.filter(
            //     (x) => labels.length === 0 || labels.includes(x[id]),
            // );
        },
        throwALease(row) {
            this.$confirm("是否确定要退租吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {

                    updateAjFittingsReturnStore({ afId: row.afId }).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "退还成功!",
                            });

                            this.partserch()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        openLoading() {
            //loading请求等待
            this.loadings = this.$loading({
                lock: true,
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        },

        Out(command) {
            console.log(command);
            if (this.selectedRowKeysCollection.length == 0 && !command) {
                this.$message({
                    showClose: true,
                    message: "请选择",
                    type: 'danger'
                });
            } else if (this.selectedRowKeysCollection.length > 0 && !command) {
                console.log('开始导出', this.selectedRowKeysCollection)
                this.openLoading()
                exportAjFittings({ afIds: this.selectedRowKeysCollection.toString() }).then(res => {
                    if (res.status == 200) {
                        this.loadings.close()
                        window.location.href = res.data;
                        this.$message({
                            type: "success",
                            message: '导出成功',
                        });
                        this.checkboxOption.selectedRowKeys = this.selectedRowKeysCollection = []

                    }
                })
            } else {
                this.openLoading()
                exportAjFittings({ exportType: 1 }).then(res => {
                    if (res.status == 200) {
                        this.loadings.close()
                        window.location.href = res.data;
                        this.$message({
                            type: "success",
                            message: '导出成功',
                        });


                    }
                })
            }
        },


        // searchByNameField(labels, id) {
        //     this.bulkData = this.bulkDataCopy.filter(
        //         (x) => labels.length === 0 || labels.includes(x[id]),
        //     );
        // },
        bulkImportClick() {
            if (this.sitId == '') {
                this.$message({
                    showClose: true,
                    message: "请导入资料",
                    type: 'danger'
                });
            } else {
                uploadImportAjFittings({
                    sitId: this.sitId
                }).then(res => {
                    this.getList()
                    this.bulkImport = false;
                    this.bulkData = [];
                    this.bulkDataCopy = [];
                    this.sitId = '';
                    this.$refs['bulk'].clearFiles()

                    this.$message({
                        type: 'success',
                        message: '导入成功!'
                    });
                })
            }

        },
        async updatabulk(file, fileList) {

            console.log(file, fileList);
            let Data = new FormData();
            Data.append('file', file.raw)
            this.openLoading()
            uploadAjFittings(Data).then(res => {
                console.log("上传成功")
                this.loadings.close()
                this.bulkData = res.data.data.resultList;
                this.bulkDataCopy = res.data.data.resultList;
                this.importData = res.data.data.importData;
                this.sitId = res.data.data.sysImportTem.sitId;

            })
        },
        bulkImportClose(done) {
            this.$confirm('确认关闭？')
                .then(_ => {
                    done();
                    this.bulkData = [];
                    this.bulkDataCopy = [];

                    this.$nextTick(() => {
                        this.getList()
                    })
                    this.$refs.bulk.clearFiles();
                })
                .catch(_ => { });
        },

        downloadFile(url, name) {//下载
            if (!url) {
                return
            }
            let link = document.createElement('a');
            link.style.display = 'none';
            link.href = url;
            link.onload = function () {
                document.body.removeChild(link);
            };
            link.setAttribute('download', name);
            document.body.appendChild(link);
            link.click();
        },
        removeAfter(file) {
            const url = this.form.afFiles.findIndex(item => item === file)
            this.form.afFiles.splice(url, 1)
        },
        sureDate() {
            this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var jsonObj = {};
                    let formData = new FormData();
                    formData.append(this.dateKeys, this.dateUpdata);
                    formData.forEach((value, key) => (jsonObj[key] = value));
                    jsonObj.afId = this.keysId
                    updateAjFittings(jsonObj).then(res => {
                        if (res.status == 200) {
                            this.$nextTick(() => {
                                console.log(this.tableData[this.dateIndexs], this.dateKeys);
                                this.tableData[this.dateIndexs][this.dateKeys] = this.dateUpdata
                            });
                            this.dbtrue = false;
                            this.$message({
                                type: "success",
                                message: "编辑成功!",
                            });
                        }

                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        getdbtrue(val, key, index, id) {
            console.log("双击", val, key, index);
            this.dbtrue = true;
            this.dateUpdata = val;
            this.dateKeys = key;
            this.dateIndexs = index;
            this.keysId = id

        },

        // 故障
        addBreak(val) {
            this.$nextTick(() => {
                this.formBk.aahThisId = val.afId;
                this.formBk.aahType = 2;
                this.formBk.name = val.afName;
            })

            this.ISBreak = true;
        },
        sureBreak() {
            this.$confirm("是否确定要报告故障吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    addAjAssetsHitch(this.formBk).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "出借成功!",
                            });
                            this.CloseBreak()
                            this.getList()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })

        },
        CloseBreak() {
            this.ISBreak = false;

            this.$refs['formBk'].resetFields();
        },

        // 上传图片
        fileChange(file) {

            if (this.form.afFiles.length > 0 && this.form.afFiles) {
                this.form.afFiles.push(...file)
            } else {
                this.$set(this.form, 'afFiles', file)
            }
            this.$message({
                type: "success",
                message: "上传成功!",
            });

        },

        addBorrow(val, id) {
            this.$nextTick(() => {

                this.formBw.aubrThisId = val.afId;
                this.formBw.aubrType = 2;
                this.formBw.aubrBorrowReturn = id;
                this.formBw.name = val.afName;
            })

            this.ISborrow = true;
        },
        sureBorrow() {
            this.$confirm("是否确定要出借吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    addAjUserBorrow(this.formBw).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "出借成功!",
                            });
                            this.CloseBorrow()
                            this.getList()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })

        },
        CloseBorrow() {
            this.ISborrow = false;

            this.$refs['formBw'].resetFields();
        },

        sureRelated() {
            this.$confirm("是否确定要添加吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    updateAjFittingsAssets({ afId: this.DetailArr.afId, aaId: this.form.aaId }).then(res => {
                        if (res.data) {
                            this.Related = false;
                            this.getDetail(this.DetailArr.afId)
                            this.$message({
                                type: "success",
                                message: "添加成功!",
                            });
                        }
                    })

                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        addRelated() {
            this.form.aaId = this.DetailArr.aaId || '';
            this.Related = true;
        },
        removeRelated() {
            this.$confirm("是否确定要解除吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    updateAjFittingsAssetsUnbinding({ afId: this.DetailArr.afId }).then(res => {
                        if (res.data) {
                            this.Related = false;
                            this.getDetail(this.DetailArr.afId)
                            this.$message({
                                type: "success",
                                message: "解除成功!",
                            });
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        closeSizer() {
            this.formDatas = {
                afBorrowAuName: '',
                auBelong: '',
                auDepartment: '',
                aaId: '',
                afName: '',
                afNumber: '',
                afcId: '',
                amId: '',
                afOwnerType: '',
                afStatus: '',
                dmDelete: 1,
                currentPage: 1,
                pageSize: 20,
            };
            this.IsSerch = false;
            this.partserch()
        },
        SerchMore() {
            this.IsSerch = true;
        },
        getDetail(id) {
            getAjFittingsDetails({ afId: id }).then(res => {
                this.DetailArr = res.data;
                this.IsDetail = true;
                console.log(this.DetailArr);
            })
        },
        handleDelete(row) {
            this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {

                    deleteAjFittings({ afIds: row.afId }).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "删除成功!",
                            });

                            this.partserch()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleEdit(row) {
            const data = JSON.parse(JSON.stringify(row))
            this.dialog = true;
            this.edit = true;
            this.$nextTick(() => {
                this.form = data;
                this.form.afFiles =data.afFiles? data.afFiles.split(','): [];
                console.log(this.form.afFiles);
                if (data.afFiles.length > 0) {
                    this.form.afFiles.forEach((item, index) => {
                        const img = {
                            name: item,
                            url: item,
                        }
                        this.$set(this.fileList, index, img)
                    })

                }
            })

        },
        SureBtn() {
            if (!this.edit) {
                this.$confirm("是否确定要新增, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        this.form.afFiles = this.form.afFiles.toString()
                        addAjFittings(this.form).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "新增成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            } else {
                this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        this.form.afFiles = this.form.afFiles.toString()
                        updateAjFittings(this.form).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "编辑成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }

        },
        BoxOpen() {
            this.dialog = true;

        },
        // 关闭弹框
        handleClose() {
            this.dialog = false;
            this.edit = false;
            this.$nextTick(() => {
                this.fileList = []
                this.$refs['formRef'].resetFields();
            })
        },
        // 修改单元格
        async beforeCellValChange(row, column, changeValue) {
            if (row[column.field] == changeValue) {
                return false;
            }

            this.$confirm("此操作将编辑该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var jsonObj = {};
                    let formData = new FormData();
                    formData.append(column.field, changeValue);
                    formData.forEach((value, key) => (jsonObj[key] = value));
                    jsonObj.afId = row.afId
                    console.log(jsonObj);
                    updateAjFittings(jsonObj).then(res => {
                        this.$message({
                            type: "success",
                            message: "编辑成功!",
                        });
                    })

                })
                .catch(() => {
                    this.lastValue = row[column.field];
                    this.$nextTick(() => {
                        this.tableData.forEach((item) => {
                            for (let key in item) {
                                if (key == column.field && item[key] == changeValue) {
                                    item[key] = this.lastValue;
                                }
                                console.log(key);
                            }
                        });
                    });
                    this.$message({
                        type: "info",
                        message: "已取消编辑",
                    });
                    return false;
                });
        },
        afterCellValChange(row, column, changeValue) {
            // console.log(" afterCellValChange", row, column, changeValue);
        },
        // reset selectedRowKeys
        resetSelectedRowKeys() {
            console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
            this.checkboxOption.selectedRowKeys = [];

            const selectedRowKeysCollection = this.selectedRowKeysCollection;

            if (selectedRowKeysCollection.length) {
                this.tableData.forEach((item) => {
                    if (selectedRowKeysCollection.indexOf(item.afId) > -1) {
                        console.log(item);
                        this.checkboxOption.selectedRowKeys.push(item.afId);
                    }
                });
            }
        },
        // select all change
        changeSelectAll(isSelected, selectedRowKeys) {
            console.log(isSelected, selectedRowKeys);
            this.checkboxOption.selectedRowKeys = selectedRowKeys;

            if (isSelected) {
                this.selectedRowKeysCollection = this.selectedRowKeysCollection.concat(selectedRowKeys) || [];
            } else {
                this.tableData.forEach((item, index) => {
                    if (this.selectedRowKeysCollection.indexOf(item.afId) > -1) {
                        this.selectedRowKeysCollection.splice(this.selectedRowKeysCollection.indexOf(item.afId), 1);
                    }
                });
            }
        },
        changeSelectedRowKeys(row, isSelected) {
            const rowKey = row.afId;

            if (isSelected) {
                this.checkboxOption.selectedRowKeys.push(rowKey);
                this.selectedRowKeysCollection.push(rowKey);
                console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
            } else {
                const index = this.checkboxOption.selectedRowKeys.indexOf(rowKey);
                this.checkboxOption.selectedRowKeys.splice(index, 1);
                this.selectedRowKeysCollection.splice(index, 1);
            }
        },
        pageSizeChange(pageSize) {

            this.formDatas.pageSize = pageSize;
            this.partserch();


        },
        pageNumberChange(pageIndex) {
            console.log(pageIndex);
            this.formDatas.currentPage = pageIndex;
            getAjFittingsList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys();
                // this.$message({
                //     type: "success",
                //     message: "搜索成功!",
                // });
            });

        },
        partserch() {
            this.formDatas.currentPage = 1;
            getAjFittingsList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys();
                // this.$message({
                //     type: "success",
                //     message: "搜索成功!",
                // });
            });
        },
        getList() {
            getAjFittingsList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
            });
        },
    },
};
</script>

<style>
.table-header-cell-class {
    background: var(--bg-color) !important;
    color: var(--font-color) !important;
    border-right: 0px !important;
}

.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}
</style>